import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components'
import type { FieldSchema } from '@/stores'
import { useDialogActions, useFilters } from '@/stores'
import { FieldItem } from './FieldItem'
import { AddFilterTrigger } from './Trigger'

export interface AddFilterButtonProps {
  dialogId: string
  schema: FieldSchema[]
  className?: string
}

export function AddFilterButton({
  dialogId,
  schema,
  className,
}: AddFilterButtonProps) {
  const filters = useFilters()
  const { openDialog } = useDialogActions()

  const availableFields = schema.filter((field) => {
    if (field.hidden) return false
    if (field.type === 'select' && field.multiple === false) {
      return !filters.some((f) => f.field === field.field)
    }
    return true
  })

  if (availableFields.length === 1) {
    const schema = availableFields[0]
    return (
      <AddFilterTrigger
        className={className}
        onClick={() => openDialog(dialogId, { schema })}
      />
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <AddFilterTrigger className={className} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {availableFields.map((fieldSchema) => (
          <FieldItem
            key={fieldSchema.field}
            schema={fieldSchema}
            dialogId={dialogId}
          />
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
